import { PRODUCTION, DEVELOPMENT, LOCAL_TRADE_MAP_URL } from "./const";
import { isEmpty } from "lodash";

export function tradeMapUrl() {
  const REACT_ENV = process.env.REACT_APP_HOST_ENV;
  const TRADE_MAP_URL = !!process.env.REACT_APP_TRADE_MAP_URL && process.env.REACT_APP_TRADE_MAP_URL !== "" ? process.env.REACT_APP_TRADE_MAP_URL : "";
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return TRADE_MAP_URL;
      case PRODUCTION:
        return TRADE_MAP_URL;
      default:
        return LOCAL_TRADE_MAP_URL;
    }
  } else {
    return LOCAL_TRADE_MAP_URL;
  }
}

export const getTradeMapUrl = () => {
  return `${tradeMapUrl()}`;
};
